// Recoil
import { useRecoilState } from "recoil";
import { cartState } from "../../../atom/menu";
// Assets
import { ControllerPropsTypes } from "../../../assets/Type";

function ControllerOrder(props: ControllerPropsTypes) {
  // Recoil State
  const [cartData, setCartData] = useRecoilState(cartState);

  // Function
  const addOrder = () => {
    const prevMenu = props.order;
    const prevMenu2 = props.menu;
    const optionData = props.option;
    if (prevMenu) {
      const prev = [...cartData!];
      prev.splice(
        prev.findIndex((v) => v.name === prevMenu.name),
        1,
        { ...prevMenu!, ea: prevMenu!.ea + 1 }
      );
      setCartData(prev);
    }
    if (prevMenu2) {
      const prev = [...cartData!];
      prev.splice(
        prev.findIndex((v) => v.name === prevMenu2.name),
        1,
        {
          ...prevMenu2!,
          ea: prev.find((v) => v.name === prevMenu2.name)!.ea + 1,
          option: prev.find((v) => v.name === prevMenu2.name)!.option,
        }
      );
      setCartData(prev);
    }
    if (optionData) {
      if (props.actionAdd) {
        props.actionAdd(optionData);
      }
    }
  };

  const deleteOrder = () => {
    const prevMenu = props.order;
    const prev = [...cartData!];
    const prevMenu2 = props.menu;
    const optionData = props.option;
    if (prevMenu) {
      if (props.value > 1) {
        prev.splice(
          prev.findIndex((v) => v.name === prevMenu.name),
          1,
          { ...prevMenu!, ea: prevMenu!.ea - 1 }
        );
      } else {
        prev.splice(
          prev.findIndex((v) => v.name === prevMenu.name),
          1
        );
      }
      setCartData(prev);
    }
    if (prevMenu2) {
      const prev = [...cartData!];
      if (prev.find((v) => v.name === prevMenu2.name)!.ea > 1) {
        prev.splice(
          prev.findIndex((v) => v.name === prevMenu2.name),
          1,
          {
            ...prevMenu2!,
            ea: prev.find((v) => v.name === prevMenu2.name)!.ea - 1,
            option: null,
          }
        );
      } else {
        prev.splice(
          prev.findIndex((v) => v.name === prevMenu2.name),
          1
        );
      }
      setCartData(prev);
    }
    if (optionData) {
      if (props.actionMinus) {
        props.actionMinus(optionData);
      }
    }
  };

  return (
    <div
      className='flex row center'
      style={{ gap: 8, width: "fit-content", marginTop: 8 }}
    >
      <div
        className='control-btn-small'
        onClick={(e) => {
          e.stopPropagation();
          deleteOrder();
        }}
      >
        {props.value === 0 ? (
          <img src={`/assets/images/menu/minus.svg`} alt={"minuse button"} />
        ) : (
          <img src={`/assets/images/menu/minus2.svg`} alt={"minuse button"} />
        )}
      </div>

      <div className='control-count-small TO-price-2 text-color-black'>
        {props.value}
      </div>

      <div
        className='control-btn-small'
        onClick={(e) => {
          e.stopPropagation();
          addOrder();
        }}
      >
        <img src={`/assets/images/menu/plus.svg`} alt={"plus button"} />
      </div>
    </div>
  );
}
export default ControllerOrder;
